import CloudProviderIcon from 'components/IntegrationTypeIcon';
import { Tooltip } from 'components/Tooltip';
import { truncateText } from 'lib/helper';
import React, { useState } from 'react';
import IntegrationDetailsDialog from 'views/Admin/Dashboard/BPADashboard/IntegrationListing/components/IntegrationDetailsDialog';

import { getIntegrationDisplayName } from './BPAIntegrationCell.utils';
import { BPAFinding } from '../../types/bpaFindings.types';

interface Props {
  row: BPAFinding;
}

/**
 * Displays the compact integration identity used by the BPA findings grid and
 * opens the existing integration-details experience from the integration name.
 */
const BPAIntegrationCell = ({ row }: Props) => {
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const fullName = row.integration_integration_label || '—';
  const subtitle = [
    row.integration_module_code,
    row.region ? `(${row.region})` : null,
  ]
    .filter(Boolean)
    .join(' - ');
  const tooltipContent = (
    <>
      <strong>Integration name:</strong>&nbsp;&nbsp;{fullName}
      <br />
      Click the integration name to view integration details.
    </>
  );

  return (
    <>
      <Tooltip tooltip={tooltipContent} showIcon={true} title="Integration">
        <div>
          <div className="d-flex align-items-center" style={{ gap: 6 }}>
            {row.integration_provider_code ? (
              <CloudProviderIcon
                cloudProviderType={row.integration_provider_code}
                size={16}
              />
            ) : null}
            <span
              role="button"
              tabIndex={0}
              style={{
                cursor: 'pointer',
                textDecoration: 'underline',
                textDecorationStyle: 'solid',
              }}
              onClick={() => {
                if (row.integration_id) setIsDetailOpen(true);
              }}
              onKeyDown={(event) => {
                if (
                  row.integration_id &&
                  (event.key === 'Enter' || event.key === ' ')
                ) {
                  event.preventDefault();
                  setIsDetailOpen(true);
                }
              }}
            >
              {getIntegrationDisplayName(fullName, truncateText)}
            </span>
          </div>
          {subtitle && <div className="text-muted small">{subtitle}</div>}
        </div>
      </Tooltip>

      {row.integration_id && (
        <IntegrationDetailsDialog
          integrationId={row.integration_id}
          isOpen={isDetailOpen}
          onClose={() => setIsDetailOpen(false)}
        />
      )}
    </>
  );
};

export default BPAIntegrationCell;
